import { Currency } from '@flixbus/honeycomb-react';
import { DiscountType, DiscountTypeMap } from '../../types/Voucher';

const OverviewDiscountTypeFields = (data: DiscountType) => {
  const valueFields = [];

  const getPercentage = (amount: number) => {
    return `${(amount * 100).toString()}%`;
  };

  if ('quantity' in data) {
    valueFields.push({
      label: DiscountTypeMap[data.type],
      value: data.quantity,
    });
  }

  if ('credit' in data) {
    valueFields.push({
      label: 'Credit Balance',
      value: <Currency value={data.credit.amount} code={data.credit.currency} />,
    });
  }

  if ('discount' in data) {
    valueFields.push({
      label: 'Discount balance',
      value: <Currency value={data.discount.amount} code={data.discount.currency} />,
    });
  }

  if ('percentage' in data) {
    valueFields.push({
      label: 'Discount value',
      value: getPercentage(data.percentage),
    });
  }

  return valueFields;
};

export default OverviewDiscountTypeFields;
